import { GetStaticPaths, GetStaticProps } from "next";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import Menu from "@/components/layout/Menu";
import ListingPageNotFound from "@/components/listing/ListingPageNotFound";
import ListingPage, {
  DetailGetPaths,
  DetailGetProps,
} from "@/components/ListingPage";
import ListingMetaHeader from "@/components/layout/ListingMetaHeader";
import Snippets from "@/components/layout/Snippets";

export interface Props {
  content: any;
  vehicleData: any;
  similarData: any;
  headers: any;
  banner?: any;
  extraDataForSold: any;
}
function SlugPage({
  content,
  vehicleData,
  similarData,
  headers,
  banner,
  extraDataForSold,
}: Props) {
  try {
    const data: any = content;

    if (data != null) {
      return (
        <div className="w-full">
          <ListingMetaHeader data={data} />
          <Snippets snippets={headers} />
          <Header banner={banner} />
          <Menu />
          <ListingPage
            content={content}
            vehicleData={vehicleData}
            similarData={similarData}
            extraDataForSold={extraDataForSold}
            headers={headers}
          />
          <Footer />
        </div>
      );
    } else {
      return (
        <>
          <Menu />
          <ListingPageNotFound />
          <Footer />
        </>
      );
    }
  } catch (e) {
    console.log("Page failed - ", e);
    return <div>something went wrong.</div>;
  }
}

export const getStaticPaths: GetStaticPaths = DetailGetPaths;

export const getStaticProps: GetStaticProps<Props> = async (context) => {
  const detailProps = await DetailGetProps(context);
  if (!detailProps.props.content) {
    return { notFound: true };
  }
  const { content } = detailProps.props;
  if (
    content?.status == "deactivated" ||
    content?.status == "pending" ||
    content?.status === "expired" ||
    content?.status === "expiredGrace" ||
    content?.status === "removed" ||
    // A buyer's copy of a vehicle they bought is never a public listing: served, it presents the
    // buyer as the seller of their own car (PA-6195). New ones are created private (PA-6194);
    // this also closes the ones created public before that.
    content?.status === "purchased" ||
    content?.displayType == "private"
  ) {
    return { notFound: true };
  }

  return {
    ...detailProps,
    revalidate: 60, // ISR: Regenerate page every 60 seconds
  };
};

export default SlugPage;
